// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DocumentUpload_modalWrapper__9-8H7 {
  /* max-width: 1200px !important; */
  /* margin: 20px; */
}

.DocumentUpload_modalWrapper2__4qwyP {
  max-width: 800px !important;
  margin: 30px;
}

/* HTML: <div class="loader"></div> */
.DocumentUpload_loader__ISE5- {
  width: 50px;
  padding: 8px;
  aspect-ratio: 1;
  border-radius: 50%;
  background: #25b09b;
  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;
  mask: var(--_m);
  mask-composite: subtract;
  animation: DocumentUpload_l3__q4KAm 1s infinite linear;
}
@keyframes DocumentUpload_l3__q4KAm {
  to {
    transform: rotate(1turn);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/upload/DocumentUpload/DocumentUpload.module.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,4EAA4E;EAE5E,eAAe;EAEf,wBAAwB;EACxB,sDAAgC;AAClC;AACA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".modalWrapper {\n  /* max-width: 1200px !important; */\n  /* margin: 20px; */\n}\n\n.modalWrapper2 {\n  max-width: 800px !important;\n  margin: 30px;\n}\n\n/* HTML: <div class=\"loader\"></div> */\n.loader {\n  width: 50px;\n  padding: 8px;\n  aspect-ratio: 1;\n  border-radius: 50%;\n  background: #25b09b;\n  --_m: conic-gradient(#0000 10%, #000), linear-gradient(#000 0 0) content-box;\n  -webkit-mask: var(--_m);\n  mask: var(--_m);\n  -webkit-mask-composite: source-out;\n  mask-composite: subtract;\n  animation: l3 1s infinite linear;\n}\n@keyframes l3 {\n  to {\n    transform: rotate(1turn);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": `DocumentUpload_modalWrapper__9-8H7`,
	"modalWrapper2": `DocumentUpload_modalWrapper2__4qwyP`,
	"loader": `DocumentUpload_loader__ISE5-`,
	"l3": `DocumentUpload_l3__q4KAm`
};
export default ___CSS_LOADER_EXPORT___;
